import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ComplianceBar from "@/components/ComplianceBar";
import AgeGate from "@/components/AgeGate";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-navy">
      <AgeGate />
      <ComplianceBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
